<script setup lang="ts"></script>

<style module>
:root {
  --p-primary-25: #0074f0;
  --p-primary-50: #0074f0;
  --p-primary-100: #006adb;
  --p-primary-200: #0056b2;
  --p-primary-300: #00428a;
  --p-primary-400: #002f61;
  --p-primary-500: #001b38;
  --p-primary-600: #001b38;
  --p-primary-700: #001b38;
  --p-primary-800: #001b38;
  --p-primary-900: #001b38;
  --p-primary-950: #001b38;
}
</style>

<template><div></div></template>
